/* eslint-disable no-useless-escape */
const betteradsHead2Script = `
var postitial_redirecturl;
var prestitial_timer;
var show_overlay = window.show_overlay;

if (window.canRunAds !== undefined && screen.width <= 767 && postitial_enabled === 1) {
  bindPostitial();
}

function isScriptLoaded(scriptSrc) {
  var scriptElements = document.querySelectorAll('script[src="' + scriptSrc + '"]');
  return scriptElements.length > 0;
}

function loadScript(scriptSrc, callback) {
  var script = document.createElement('script');
  script.src = scriptSrc;

  // Execute the callback function once the script is loaded
  script.onload = callback;

  // Append the script element to the <head> or <body>
  document.head.appendChild(script);
}

var scriptSrc = 'https://securepubads.g.doubleclick.net/tag/js/gpt.js';
if (!isScriptLoaded(scriptSrc)) {
  loadScript(scriptSrc, function() {
    // Script is loaded and ready to use
    // Perform any operations that rely on the loaded script
    console.log('GPT Script is loaded after callback');
  });
}

if (typeof window.googletag !== 'undefined' && typeof googletag.pubads === 'function') {
  var val_test_adid = '';
  var val_test_plid = '';

  if (window.location.search.indexOf("test_adid") !== -1) {
      val_test_adid = parse_query_string('test_adid');
  }
  if (window.location.search.indexOf("test_plid") !== -1) {
      val_test_plid = parse_query_string('test_plid');
  }
  if (val_test_adid !== "") {
      googletag.pubads().setTargeting("test_adid", val_test_adid);
  }
  if (val_test_plid !== "") {
      googletag.pubads().setTargeting("test_plid", val_test_plid);
  }

  var key = "dfp_preview";
  if (Object.entries(dfp_preview_ids).length !== 0 && dfp_preview_ids != "") {
    googletag.cmd.push(function () {
      googletag.pubads().setTargeting(key, dfp_preview_ids);
    });
  }

  window.addEventListener('message', closetopoverlay, false);
  googletag.pubads().enableSingleRequest();
  googletag.enableServices();
} else {
  console.log('googletag.pubads() is not available');
}

function bindPostitial() {
  console.log("bindPostitial");
  //googletag.destroySlots([googletag.slots["topoverlay"]])
  document.addEventListener('click', function (event) {
    console.log("click event called");
    var anchor = event.target.closest("a");     // Find closest Anchor (or self)
    var currentdomain = window.location.href.split('/')[2];
    if (anchor !== null) {
      var anchorHref = anchor.getAttribute('href');
      //console.log(anchorHref);
      if ((anchorHref.indexOf(currentdomain) !== -1 || anchorHref.charAt(0) == "/" ) && anchorHref.match(/http(s)*:\\/\\/traffic.outbrain.com\/) == null && anchorHref.match(/http(s)*:\\/\\/subscribe.sph.com.sg\/) == null ) {
        event.preventDefault();// Don't navigate!
        postitial_redirecturl = anchorHref;
        console.log(postitial_redirecturl);
        var dfpadunits = JSON.parse(loaded_dfp_tags);
        var dynamic_postitial_template_unit = 'lb1';
        if(!dfpadunits[dynamic_postitial_template_unit]) { dynamic_postitial_template_unit = 'lb2'; }
        if(dfpadunits[dynamic_postitial_template_unit]) { var dynamic_postitial = dfpadunits[dynamic_postitial_template_unit]['adunit']; }
        // var dynamic_postitial = dfpadunits[dynamic_postitial_template_unit]['adunit'];
        if (typeof dynamic_postitial !== "undefined" ) {
          console.log("dynamic_postitial");
          dynamic_postitial = dynamic_postitial.replace( "/"+dynamic_postitial_template_unit+"/" , "/postitial/" );
          if ((topOverlayImpressionsServed < topOverlayImpressions && document.cookie.indexOf("postitialDisplayed=") == -1) || (dfp_preview_ids != undefined && dfp_preview_ids.length != 0) ) {
            const myPageOverlay = document.getElementById("MyPageOverlay");
            if (myPageOverlay) { myPageOverlay.className = "overlayWhite"; }
            googletag.cmd.push(function () {
              var slot_topoverlay = googletag.defineSlot( dynamic_postitial , [1,1], 'postitial_holder' ).addService(googletag.pubads()).setTargeting("pos", "postitial");
              googletag.pubads().addEventListener('slotRenderEnded',function (eventtopoverlay) {
                if(slot_topoverlay == eventtopoverlay.slot) {
                  if (eventtopoverlay.isEmpty) {
                    console.log("empty postitial");
                    window.location.href = postitial_redirecturl;
                  }
                  else {
                    unloadScrollBars();
                    var expiry = new Date();expiry.setTime(expiry.getTime() + (postitial_validity * 60 * 60 * 1000));
                    topOverlayImpressionsServed = topOverlayImpressionsServed + 1;
                    if(topOverlayImpressionsServed == topOverlayImpressions) {
                      document.cookie = "postitialDisplayed=yes;path=/; expires=" + expiry.toGMTString();
                      document.cookie = "topOverlayImpressionsServed=0;path=/; expires=" + expiry.toGMTString();
                    } else {
                      document.cookie = "topOverlayImpressionsServed=" + topOverlayImpressionsServed + ";path=/; expires=" + expiry.toGMTString();
                    }
                    window.clearTimeout(postitial_timer);
                  }
                }
              });
              googletag.cmd.push( function () {
                googletag.display( 'postitial_holder' );
                googletag.pubads().refresh([slot_topoverlay], { changeCorrelator: false });
              });
            });
          }
          else {
            console.log("Postitial frequency cap from cookie");
            window.location.href = postitial_redirecturl;
          }
          var postitial_timer = window.setTimeout(kill_postitial, 15000);
        }
        else {
          window.location.href = postitial_redirecturl;
        }
      }
    }
  }, true);
}
`;

export default betteradsHead2Script;
